<script setup lang="ts">
import DreamaProgressiveImage from '@/components/dreama-progressive-image'
import type { Props } from './type'

defineOptions({
  name: 'DistributeDreamaImage',
})

withDefaults(defineProps<Props>(), {
  src: null,
  alt: '',
  aspectRatio: '1 / 1',
  objectFit: 'cover',
  loading: 'lazy',
  sourceType: 'image',
  priority: false,
  previewWidth: null,
  requestWidth: null,
})

defineEmits<{
  'preview-ready': []
}>()
</script>

<template>
  <DreamaProgressiveImage
    :src="src"
    :alt="alt"
    :aspect-ratio="aspectRatio"
    :object-fit="objectFit"
    :loading="loading"
    :source-type="sourceType"
    :priority="priority"
    :preview-width="previewWidth"
    :request-width="requestWidth"
    @preview-ready="$emit('preview-ready')"
  />
</template>
